<template>
  <!--
      作者 gmshop
      时间：2012-12-5
      描述：设置-设置
  -->
  <div class="product-add" v-loading="loading">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px" v-if="!loading">
      <!--添加门店-->
      <div class="common-form">区域奖励设置</div>
      <el-form-item label="是否开启区域代理奖励：">
        <el-radio-group v-model="form.is_open">
          <el-radio :label="0">关闭</el-radio>
          <el-radio :label="1">开启</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="奖励模式：">
        <el-radio-group v-model="form.award_mode">
          <el-radio :label="0">普通</el-radio>
          <el-radio :label="1">差价</el-radio>
        </el-radio-group>
        <div class="red">普通模式：按照实际设定奖励计算；差价模式：高级实际奖励会扣除低级已经获得的奖励</div>
      </el-form-item>
      <el-form-item label="省级区域奖" :rules="[{required: true,message: ' '}]" prop="province_rate">
        <el-input v-model="form.province_rate" type="number" :min="0" :max="50" :step="1" placeholder="请输入比例" class="max-w460"><template slot="append">%</template></el-input>
        <div class="gray9">规则：成为省级区域代理后，该地区的实付金额 的 {{form.province_rate}}% 收益奖励</div>
      </el-form-item>
      <el-form-item label="市级区域奖" :rules="[{required: true,message: ' '}]" prop="city_rate">
        <el-input v-model="form.city_rate" type="number" :min="0" :max="50" :step="1" placeholder="请输入比例" class="max-w460"><template slot="append">%</template></el-input>
        <div class="gray9">规则：成为市级区域代理后，该地区的实付金额 的 {{form.city_rate}}% 收益奖励</div>
      </el-form-item>
      <el-form-item label="区级区域奖" :rules="[{required: true,message: ' '}]" prop="region_rate">
        <el-input v-model="form.region_rate" type="number" :min="0" :max="50" :step="1" placeholder="请输入比例" class="max-w460"><template slot="append">%</template></el-input>
        <div class="gray9">规则：成为区级区域代理后，该地区的实付金额 的 {{form.region_rate}}% 收益奖励</div>
      </el-form-item>

      <!-- <div class="common-form">区域代理说明</div>
      <el-form-item label="内容" >
        <div class="edit_container">
          <Uediter v-model="form.content" id="ue" :text="form.content" :config="ueditor.config" ref="ue"></Uediter>
        </div>
      </el-form-item> -->
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>

</template>

<script>
  import RegionAgentApplyApi from '@/api/plus/regionagentapply.js';
  import Uediter from '@/components/UE.vue';
  import { formatModel } from '@/utils/base.js';
  export default {
    components:{
      Uediter
    },
    data() {
      return {
        /*是否正在加载*/
        loading: true,
        /*form表单数据*/
        form: {
          is_open: 0,//省区域奖励
          award_mode: 0,//
          province_rate: 0,//省区域奖励
          city_rate: 0,//市区域奖励
          region_rate: 0,//区级区域奖励
          content: ''
        },

        /*是否打开图片选择*/
        isupload:false,
        /*富文本配置*/
        ueditor: {
          text: '',
          config: {
            initialFrameWidth: 400,
            initialFrameHeight: 500
          }
        }
      };
    },
    created() {
      this.getParams()
    },

    methods: {

      /*获取配置数据*/
      getParams() {
        let self = this;
        RegionAgentApplyApi.setDetail({}, true).then(res => {
            let vars = res.data.vars.values;
            self.form = formatModel(self.form, vars);
            self.form.is_open = vars.is_open || self.form.is_open;
            self.form.award_mode = vars.award_mode || self.form.award_mode;
            self.form.province_rate = vars.province_rate || self.form.province_rate;
            self.form.city_rate = vars.city_rate || self.form.city_rate;
            self.form.region_rate = vars.region_rate || self.form.region_rate;
            self.form.content = vars.content || self.form.content;
            self.loading=false;
          })
          .catch(error => {
            self.loading=false;
          });

      },


      /*提交*/
      onSubmit() {
        let self = this;
        let params = this.form;

        // params.content = this.$refs.ue.getUEContent();

        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            RegionAgentApplyApi.editSet(params, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你，设置成功',
                  type: 'success'
                });
                self.$router.push('/regionagent/setting/index');
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });
      },
      //监听复选框选中
      handleCheckedGetLog(e) {

      },
    }

  };
</script>
<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/regionagent/setting/index.vue